import { render, staticRenderFns } from "./EduCourseXianXia.vue?vue&type=template&id=382e05cb&scoped=true"
import script from "./EduCourseXianXia.vue?vue&type=script&lang=js"
export * from "./EduCourseXianXia.vue?vue&type=script&lang=js"
import style0 from "./EduCourseXianXia.vue?vue&type=style&index=0&id=382e05cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e05cb",
  null
  
)

export default component.exports